import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
import NavBar from "./Component/NavBar/NavBar";
import "./css/Colors.css";
import "./css/Layout.css";
import { useAuth } from "./API/auth";
import { fetchCurrentEnvironment } from "./API/agromanager/agromanager";
import { useUserData } from "./Component/AuthGuard/useUserData";

type LayoutProps = {
  children: React.ReactNode;
};

export const theme = createTheme({
  palette: {
    primary: {
      main: "#50BE64",
      contrastText: "hsl(0, 0%, 100%, 1)",
    },
    secondary: {
      main: "#618c85",
      dark: "#0f5046",
      light: "#b0c5c2",
    },
    text: {
      primary: "#00323c",
    },
    warning: {
      main: "#fa9600",
    },
    error: {
      main: "#E82417",
    },
    info: {
      main: "#0672D5",
    },
  },
  typography: {
    fontFamily: "exo2, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          color: "#FFF",
          textTransform: "none",
          "&:hover": {
            color: "#FFF",
          },
        },
        text: {
          color: "#618C85",
          backgroundColor: "transparent",
          "&:hover": {
            color: "#0F5046",
            backgroundColor: "transparent",
          },
        },
        outlined: {
          color: "#618C85",
          backgroundColor: "#F0FFF5",
          border: "solid 1px #C3DCD2",
          "&:hover": {
            color: "#0F5046",
            borderColor: "#C3DCD2",
            backgroundColor: "#C3DCD2",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFF",
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFF",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(97,140,133,0.2)",
          },
        },
      },
    },
  },
});

export default function Layout({ children }: LayoutProps) {
  const { isAgromanagerUser } = useUserData();
  const { setAgroManagerEnv, accessToken } = useAuth();

  React.useEffect(() => {
    if (isAgromanagerUser && accessToken) {
      fetchCurrentEnvironment().then((env) => {
        setAgroManagerEnv(env);
      });
    }
  }, [isAgromanagerUser, accessToken]);

  return (
    <ThemeProvider theme={theme}>
      <div className="app-root">{children}</div>
    </ThemeProvider>
  );
}

export function Splash({ children }: LayoutProps): React.ReactNode {
  return (
    <>
      <NavBar hasDrawer={false} />
      <div className="splash">
        <div className="splash-inner">{children}</div>
      </div>
    </>
  );
}
